import { render, staticRenderFns } from "./add.vue?vue&type=template&id=36b3ae92&scoped=true&"
var script = {}
import style0 from "./add.vue?vue&type=style&index=0&id=36b3ae92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3ae92",
  null
  
)

export default component.exports